import { previousLocationSelectorFactory } from '@ackee/redux-utils/routing-history';
import type { RootState } from '../../redux';
import { ROUTING_HISTORY_MODULE_NAME } from '../constants';

export const previousLocationSelector = previousLocationSelectorFactory<RootState, typeof ROUTING_HISTORY_MODULE_NAME>(
    ROUTING_HISTORY_MODULE_NAME,
);
